module.exports = "/static-assets/_next/static/images/bg-desktop-7d6ebe7c2966bdf08f32fe4b67c889f3.jpg";